import {
  Box,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import TopBar from './TopBar';
import NotificationContainer from './NotificationsContainer';
import PrivacyContainer from './PrivacyContainer';
import ManagementContainer from './ManagementContainer';
import FRTManagementContainer from './FRTManagementContainer';
import MobileSettings from './MobileSettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Correctly fetch the user object from Redux, similar to Navbar.js
  const { user } = useSelector((state) => state.user?.user || {});
  
  // Only the MBF Admin (who has is_org_admin = true) should see the Management tabs.
  // All other TLs should only see Notification and Privacy.
  const showManagementTabs = Boolean(user?.is_org_admin);

  const renderPage = () => {
    switch (activeTab) {
      case 0:
        return <NotificationContainer />;
      case 1:
        return <PrivacyContainer />;
      case 2:
        return showManagementTabs ? <ManagementContainer /> : null;
      case 3:
        return showManagementTabs ? <FRTManagementContainer /> : null;
      default:
        return null;
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 500,
          mb: 3,
          color: 'text.primary',
          textAlign: 'left',
        }}
      >
        Settings
      </Typography>
      <TopBar activeTab={activeTab} setActiveTab={setActiveTab} isAdmin={showManagementTabs} />
      <Box sx={{ mt: { xs: 2, md: 4 } }}>{renderPage()}</Box>
    </>
  );
};

const SettingsContainer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // < 900px

  return (
    <Container
      maxWidth="xl"
      sx={{ py: { xs: 2, md: 4 }, px: { xs: 1.5, md: 3 } }}
    >
      {isMobile ? <MobileSettings /> : <Settings />}
    </Container>
  );
};

export default SettingsContainer;
